<template>
  <UNavigationMenu
    v-if="
      countStatusManual?.filter((x) => x === true).length !==
      countStatusManual.length
    "
    :collapsed="collapsed"
    :items="manualLists"
    orientation="vertical"
    tooltip
    popover
    :ui="{
      link: [
        collapsed ? 'justify-center' : '',
        'data-active:before:bg-primary-100!',
        'hover:before:bg-primary-50!',
      ],
    }"
  >
    <template #item-leading="{ item }">
      <template v-if="item.type !== 'label'">
        <UBadge
          v-if="item.active === true"
          class="rounded-full m-0 p-1 item-active"
        >
          <UIcon
            name="i-lucide-check"
            class="size-2.5"
          />
        </UBadge>
        <UIcon
          v-else
          name="i-lucide-circle"
          class="size-4.5"
        />
      </template>
    </template>
    <template #item-label="{ item }">
      <template v-if="item.type !== 'label'">
        <span
          class="text-sm font-normal leading-5"
          :class="{
            'line-through text-slate-500': item.active === true,
          }"
        >
          {{ item.label }}
        </span>
      </template>
      <template v-else>
        {{ item.label }}
        {{ countStatusManual?.filter((x) => x === true).length || 0 }}/{{
          countStatusManual.length
        }}
      </template>
    </template>
    <template #item-trailing="{ item }">
      <UIcon
        v-if="item.type !== 'label'"
        name="i-lucide-chevron-right"
      ></UIcon>
    </template>
  </UNavigationMenu>
</template>

<script lang="ts" setup>
import type { NavigationMenuItem } from "@nuxt/ui";
import type { OnBoardChecklist } from "@/utils/types/company";

interface Props {
  collapsed?: boolean;
  checklist?: OnBoardChecklist;
}
const props = withDefaults(defineProps<Props>(), {
  collapsed: false,
  checklist: () => ({}),
});

const authStore = useAuthStore();
const { user: currentUser } = storeToRefs(authStore);

const MENU_MANUAL_LISTS: NavigationMenuItem[][] = [
  [
    {
      label: "คู่มือเริ่มต้นใช้งาน",
      type: "label",
    },
    {
      label: "จัดการโครงสร้างองค์กร",
      key: "manage_organization",
      to: {
        name: "admin-organization-company",
      },
    },
    {
      label: "เพิ่มผู้ใช้งาน",
      key: "add_user",
      to: {
        name: "admin-organization-user",
        query: { action: "add" },
      },
    },
    {
      label: "เชื่อมต่อไลน์ผู้ใช้งาน",
      key: "connect_line",
      to: {
        name: "admin-organization-user",
        query: { action: "connect_line", user_id: currentUser.value?.id },
      },
    },
    {
      label: "ตั้งค่าคำถามรายงาน",
      key: "set_questionnaire",
      to: {
        name: "admin-report-question",
      },
    },
    {
      label: "ตั้งค่าแบบทดสอบบันทึกเสียง",
      key: "set_audio_record_question",
      to: {
        name: "admin-audio-record-config",
        query: { tab: "result" },
      },
    },
    {
      label: "ตั้งค่าการส่งออกแบบทดสอบ",
      key: "send_audio_record_question",
      to: {
        name: "admin-audio-record-config",
        query: { tab: "publish" },
      },
    },
  ],
];

const manualLists = computed(() =>
  MENU_MANUAL_LISTS?.map((x) => [
    ...(x
      ?.map((y) => ({
        ...y,
        active:
          props.checklist[y?.key] !== undefined &&
          props.checklist[y?.key] === true,
      }))
      ?.map((y) => ({
        ...y,
        to: y.active === true ? undefined : y.to,
      })) || []),
  ]),
);

const countStatusManual = computed(() => {
  return manualLists.value[0]
    ?.filter((x) => x.type !== "label")
    ?.map((x) => x.active === true);
});
</script>

<style></style>
